import { styled as t, Box as n, Typography as a } from "@mui/material";
import p from "../../../assets/images/image-title-baseline.png.js";
import { jsxs as l, jsx as o } from "react/jsx-runtime";
const h = t(n)`
  align-items: center;
  column-gap: 12px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 0px;
`, g = t(n)`
  background-image: url(${`"${p}"`});
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 200% 18px;
  ${(e) => e.theme.breakpoints.up("res1024")} {
    height: 68px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    height: 55px;
  }
`, i = t(a)`
  font-weight: 300;
  -webkit-text-stroke: 6px;
  -webkit-text-stroke-color: #6a5d77;
  paint-order: stroke fill;
`, x = t(i)`
  letter-spacing: 0.5px;
  transform: scaleX(0.96);
  white-space: nowrap;

  ${(e) => e.theme.breakpoints.up("res1024")} {
    font-size: 46px;
    line-height: 53.91px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    font-size: 36px;
    line-height: 38px;
  }
`, c = t(i)`
  font-family: var(--font-Apeiron);
  ${(e) => e.theme.breakpoints.up("res1024")} {
    font-size: 20px;
    line-height: 24px;
  }
  ${(e) => e.theme.breakpoints.down("res1024")} {
    font-size: 16px;
    line-height: 18px;
  }
`, u = (e) => {
  const {
    className: s,
    text: r
  } = e;
  return /* @__PURE__ */ l(h, {
    className: s,
    children: [/* @__PURE__ */ o(g, {
      className: "Custom-Highlight",
      children: /* @__PURE__ */ o(x, {
        className: "Custom-Normal-Language",
        children: r
      })
    }), /* @__PURE__ */ o(c, {
      children: r
    })]
  });
};
export {
  u as default
};
//# sourceMappingURL=ApeironTitle.js.map
